export default "7b5a100138c727d4.svg"